import { token } from '@atlaskit/tokens';
var themedBackground = {
  light: token('color.background.default', '#FFFFFF'),
  dark: token('color.background.default', '#1B2638')
};
/**
 * Returns the background color depending on the passed through mode.
 * @param mode
 */

export var getBackground = function getBackground() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  return themedBackground[mode];
};